export default "__VITE_ASSET__BFS2eT_3__"